<template>
  <div>
    <b-row>
      <b-col md="3">
        <h6>No Label</h6>
        <hr />
        <McCheckbox v-model="selectedValue" id="checkbox1" value="checkbox" />
      </b-col>
      <b-col md="3">
        <h6>Label</h6>
        <hr />
        <McCheckbox v-model="selectedValue" id="checkbox2" :label="label" value="checkbox" />
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col md="3">
        <h6>Disabled</h6>
        <hr />
        <McCheckbox v-model="selectedValue" id="checkbox3" disabled value="checkbox" />
      </b-col>
      <b-col md="3">
        <h6>Disabled</h6>
        <hr />
        <McCheckbox
          v-model="selectedValue"
          id="checkbox4"
          :label="label"
          disabled
          value="checkbox"
        />
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col md="3">
        <h6>OnChange</h6>
        <hr />
        <McCheckbox v-model="selectedValue" @change="onChange" id="checkbox5" value="checkbox" />
      </b-col>
      <b-col md="3">
        <h6>OnChange</h6>
        <hr />
        <McCheckbox
          v-model="selectedValue"
          @change="onChange"
          id="checkbox6"
          :label="label"
          value="checkbox"
        />
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col md="3">
        <h6>Indeterminate</h6>
        <hr />
        <thead>
          <McCheckbox v-model="selectedValue" id="checkall1" value="checkbox" />
        </thead>
      </b-col>
      <b-col md="3">
        <h6>Indeterminate Label</h6>
        <hr />
        <thead>
          <McCheckbox v-model="selectedValue" id="checkall2" :label="label" value="checkbox" />
        </thead>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import McCheckbox from './index.vue'

export default {
  components: {
    McCheckbox,
  },
  props: {
    label: {
      type: String,
    },
  },

  data() {
    return {
      selectedValue: '',
    }
  },

  methods: {
    onChange() {
      alert('change')
    },
  },
}
</script>
